/* eslint-disable import/prefer-default-export */

import { Model } from './core';

export default class Partner extends Model {
  static get endpoint() {
    return 'wp/v2/partners';
  }
}
